import { Pipe, PipeTransform } from "@angular/core";

type Formats = "ncm" | "cest" | "cfop" | "cpfCnpj";

@Pipe({
  name: "formatter"
})
export class FormatterPipe implements PipeTransform {
  transform(value?: string, format?: Formats): string {
    if (!value) return "";

    switch (format) {
      case "ncm":
        return this.formatNcm(value);
      case "cpfCnpj":
        return this.formatCpfCnpj(value);
      case "cest":
        return this.formatCest(value);
      case "cfop":
        return this.formatCfop(value);
      default:
        return value;
    }
  }

  formatCfop(value: string) {
    if (value.length !== 4) return value;
    return value.replace(/(\d{1})(\d{3})/, "$1.$2");
  }

  formatCest(value: string) {
    if (value.length !== 7) return value;
    return value.replace(/(\d{2})(\d{3})(\d{2})/, "$1.$2.$3");
  }

  formatNcm(value: string) {
    if (value.length !== 8) return value;
    return value.replace(/(\d{4})(\d{2})(\d{2})/, "$1.$2.$3");
  }

  formatCpfCnpj(value: string) {
    if (value.length === 11) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (value.length === 14) {
      return value.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    } else {
      return value;
    }
  }
}
